import type { FC } from "react";

import { PageList } from "./PageList";
import { PublishingCard } from "./PublishingCard";

import { type PageChangeSummary } from "api/api-types-publishing";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { LockLockedIcon } from "mds/icons";

interface ExcludedPagesSectionProps {
  pages: PageChangeSummary[];
  sectionId: string;
  description: string;
}

export const ExcludedPagesSection: FC<ExcludedPagesSectionProps> = ({
  pages,
  sectionId,
  description,
}) => {
  if (pages.length === 0) return null;

  return (
    <PublishingCard>
      <IconText
        className="h3 mb-1 text-blue-shade-20"
        iconStart={<LockLockedIcon className="text-blue" />}
        text={t("publishing.student_submission_card.title")}
      />
      <div className="body-s mb-4 text-black-tint-20">{description}</div>
      <PageList
        pages={pages}
        sectionId={sectionId}
        showStatusChip={false}
        showViewPageHistory={false}
      />
    </PublishingCard>
  );
};
